import { render, staticRenderFns } from "./DistributorBrandTable.vue?vue&type=template&id=6347a068"
import script from "./DistributorBrandTable.vue?vue&type=script&lang=js"
export * from "./DistributorBrandTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports